<template>
  <!-- Edit Dialog -->
  <base-dialog
    v-model="dialog.show"
    max-width="650px"
    min-width="500px"
    scrollable
    @close="onDialogClose"
    :title="`${$t('sidebar.style.name')}`"
    width="50%"
  >
    <base-form ref="form" lazy-validation @submit.stop="onSubmit">
      <v-row>
        <v-col cols="12" class="py-0">
          <field-group
            v-model="dialog.data.name"
            autofocus
            inline
            :error-messages="dialog.error.name"
            filled
            label="Tên hiển thị"
            dense
            required
          ></field-group>
        </v-col>
        <v-col cols="12" class="py-0" v-if="!disabledSelectWorkspace">
          <field-group
            inline
            v-model="dialog.data.workspace_id"
            dense
            :error-messages="dialog.error.workspace_id"
            filled
            item-text="name"
            item-value="id"
            :items="workspace.items"
            required
            :label="$t('sidebar.workspace.name')"
            :loading="workspace.loading"
            type-input="v-autocomplete"
          >
          </field-group>
        </v-col>
        <v-col cols="12" class="py-0">
          <field-group
            inline
            v-model="dialog.data.layer_id"
            dense
            :error-messages="dialog.error.layer_id"
            filled
            required
            item-text="name"
            item-value="id"
            :items="layer.items"
            :label="$t('sidebar.layer.name')"
            :loading="layer.loading"
            type-input="v-autocomplete"
          >
          </field-group>
        </v-col>
        <v-col cols="12" class="pb-0">
          <h2>Nội dung trình bày</h2>
          <preview-simple-edit
            v-if="dialog.show"
            v-model="dialog.data.content"
          ></preview-simple-edit>
        </v-col>
      </v-row>
    </base-form>

    <template v-slot:extra-btn>
      <base-button
        color="primary"
        :loading="dialog.loading"
        outlined
        :type-action="dialog.type"
        @click="onSubmit"
      >
      </base-button>
    </template>
  </base-dialog>
</template>

<script>
import { EDIT_TYPE } from '@constant'
import { API_LAYER, API_STYLE } from '@api'
import { mapGetters } from 'vuex'
import PreviewSimpleEdit from './preview/edit-simple.vue'
export default {
  components: { PreviewSimpleEdit },
  props: {
    disabledSelectWorkspace: Boolean,
    workspace: { type: Object, default: () => ({}) },
  },
  data: () => ({
    dialog: {
      show: false,
      loading: false,
      data: {},
      type: EDIT_TYPE.CREATE,
      error: {},
    },
    layer: { loading: false, items: [] },
  }),
  watch: {
    'dialog.data.workspace_id': {
      handler(value) {
        this.layer.items = []
        this.layer.loading = true

        API_LAYER.list({ workspace_id: value, with: 'style' })
          .then((res) => {
            this.layer.items = res.data
            if (this.dialog.data.layer_id) {
              this.onSetDefaultStyleFromLayer(this.dialog.data.layer_id)
            }
          })
          .finally(() => {
            this.layer.loading = false
          })
      },
    },
    'dialog.data.layer_id': {
      handler: 'onSetDefaultStyleFromLayer',
    },
  },
  computed: {
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
    titleDialog() {
      if (this.isCreateDialog) {
        return this.$i18n.t('actions.add')
      } else {
        return this.$i18n.t('actions.update')
      }
    },
    isCreateDialog() {
      return this.dialog.type == EDIT_TYPE.CREATE
    },
  },
  methods: {
    onSetDefaultStyleFromLayer(value) {
      if (
        !value ||
        !this.layer ||
        !this.layer.items ||
        this.layer.items.length < 1
      )
        return
      let layer = this.layer.items.find((x) => x.id == value)
      if (!layer || !layer.style) return
      this.$set(this.dialog.data, 'content', layer.style.content)
    },
    open(item) {
      if (this.$refs.form) this.$refs.form.resetValidation()
      this.dialog.show = true
      this.dialog.type = EDIT_TYPE.UPDATE
      this.$set(
        this.dialog,
        'data',
        Object.assign({ layer_id: null, content: [] }, item)
      )
      if (item.layer) this.dialog.data.layer_id = item.layer.id
    },
    onDialogClose() {
      this.dialog = {
        show: false,
        loading: false,
        data: {},
        type: EDIT_TYPE.CREATE,
        error: {},
      }
    },
    async onSubmit() {
      this.dialog.error = {}
      if (!(await this.$refs.form.validate())) return
      try {
        let data = Object.assign({}, this.dialog.data)
        this.dialog.loading = true
        let res = await API_STYLE.create(data)

        if (res && !res.error) {
          this.onDialogClose()
          this.getData()
        }
        if (
          res &&
          res.error &&
          res.error.response &&
          res.error.response.status == 422
        ) {
          const { response } = res.error
          this.dialog.error = response.data.errors
        }
      } finally {
        this.dialog.loading = false
      }
    },
    getData() {
      this.$emit('reset')
    },
  },
}
</script>

<style scoped>
.v-btn {
  font-weight: 400;
}
</style>
